// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__1LEgU","message":"style_message__2KpfI"};